import React, { memo, useState } from 'react'
import DSRLandingPage from './dsr-landing-page'
import Spinner from '../common/dsr-spinner'
import DSRSuccess from './request-success'
import DataRequestForm from './dsr-form'

const DataRequestHome = memo((props) => {
  const [currentState, setCurrentState] = useState('HOME')
  const updateState = (state) => {
    setCurrentState(state)
  }
  const showState = (state) => {
    const DAR_STATES = {
      HOME: <DSRLandingPage changeState={updateState} {...props} />,
      DSRFORM: <DataRequestForm changeState={updateState} {...props} />,
      SUCCESS: <DSRSuccess {...props} />,
      SPINNER: <Spinner />,
    }
    return DAR_STATES[state]
  }

  return <>{showState(currentState)}</>
})
DataRequestHome.displayName = 'DataRequestHome'

export default DataRequestHome
